/**
 * LERA Gallery Navigation Engine — Sprint 8.4A.1
 * Shared media navigation for overflow, arrows, and future Premium Gallery Viewer (8.4B).
 * Reuses media-gallery.setActiveMedia — does not duplicate gallery state.
 */

(function () {
  const THUMB_SELECTOR = '.lera-gallery-thumb';
  const SLIDE_SELECTOR = '.product__media-item[data-media-id]';

  function isEligibleThumb(node) {
    if (!node || !node.classList.contains('lera-gallery-thumb')) return false;
    if (node.classList.contains('lera-media-sync--hidden')) return false;
    if (node.hasAttribute('hidden')) return false;
    return Boolean(node.dataset.target);
  }

  function isEligibleSlide(node) {
    if (!node || !node.dataset.mediaId) return false;
    if (node.classList.contains('lera-media-sync--hidden')) return false;
    if (node.hasAttribute('hidden')) return false;
    return true;
  }

  function getMediaKeys(gallery) {
    if (!gallery) return [];

    const viewerList = gallery.querySelector('.product__media-list');
    const viewerKeys = new Set(
      Array.from(viewerList?.querySelectorAll(SLIDE_SELECTOR) || [])
        .filter(isEligibleSlide)
        .map((node) => node.dataset.mediaId)
    );

    const thumbList = gallery.querySelector('.lera-gallery-thumbs__list');
    if (thumbList) {
      return Array.from(thumbList.querySelectorAll(THUMB_SELECTOR))
        .filter(isEligibleThumb)
        .map((node) => node.dataset.target)
        .filter((key) => viewerKeys.has(key));
    }

    return Array.from(viewerKeys);
  }

  function getActiveKey(gallery) {
    if (!gallery) return null;

    const activeSlide = gallery.querySelector(
      '.lera-gallery-layout__stage .product__media-item.is-active[data-media-id]'
    );
    if (activeSlide?.dataset.mediaId) return activeSlide.dataset.mediaId;

    const currentThumb = gallery.querySelector(
      `${THUMB_SELECTOR} button[aria-current="true"]`
    )?.closest(THUMB_SELECTOR);
    return currentThumb?.dataset.target || null;
  }

  function getActiveIndex(gallery) {
    const keys = getMediaKeys(gallery);
    const activeKey = getActiveKey(gallery);
    if (!activeKey) return 0;
    const index = keys.indexOf(activeKey);
    return index >= 0 ? index : 0;
  }

  function goTo(gallery, keyOrIndex) {
    if (!gallery) return null;

    const keys = getMediaKeys(gallery);
    if (!keys.length) return null;

    let targetKey = null;
    if (typeof keyOrIndex === 'number') {
      const index = ((keyOrIndex % keys.length) + keys.length) % keys.length;
      targetKey = keys[index];
    } else {
      targetKey = String(keyOrIndex);
    }

    if (!targetKey || !keys.includes(targetKey)) return null;

    if (typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(targetKey, false);
    }

    gallery.dispatchEvent(
      new CustomEvent('lera:gallery:navigate', {
        bubbles: true,
        detail: {
          targetKey,
          index: keys.indexOf(targetKey),
          keys,
        },
      })
    );

    return targetKey;
  }

  function next(gallery) {
    return goTo(gallery, getActiveIndex(gallery) + 1);
  }

  function prev(gallery) {
    return goTo(gallery, getActiveIndex(gallery) - 1);
  }

  window.LeraGalleryNav = {
    getMediaKeys,
    getActiveKey,
    getActiveIndex,
    goTo,
    next,
    prev,
    isEligibleThumb,
  };
})();
